import { SEOEnhanced, generateOrganizationSchema, generateWebsiteSchema } from "@/components/SEOEnhanced";
import { Helmet } from 'react-helmet-async';
import HeroSection from "@/components/HeroSection";
import FeaturesSection from "@/components/FeaturesSection";
import ShopSection from "@/components/ShopSection";

import IngredientsSection from "@/components/IngredientsSection";
import SubscriptionSection from "@/components/SubscriptionSection";
import NewsletterSection from "@/components/NewsletterSection";
import Footer from "@/components/Footer";
import { useSmoothScroll } from "@/hooks/useSmoothScroll";
import { ScrollReveal } from "@/components/animations/ScrollReveal";


const Index = () => {
  useSmoothScroll();

  return (
    <>
      <SEOEnhanced
        title="Premium Nootropic Energy Drinks"
        description="Experience the perfect fusion of cosmic energy and neural enhancement with SOLR's premium nootropic beverages. Scientifically formulated for peak mental performance."
        keywords="energy drinks, nootropic drinks, cognitive enhancement, mental clarity, focus drinks, brain health, premium beverages, SOLR"
      />
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(generateOrganizationSchema())}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(generateWebsiteSchema())}
        </script>
      </Helmet>
      <main className="flex-1 relative z-10">
        <HeroSection />
        <ScrollReveal delay={100}>
          <FeaturesSection />
        </ScrollReveal>
        
        <ScrollReveal delay={200}>
          <div id="shop-section">
            <ShopSection />
          </div>
        </ScrollReveal>
        
        
        <ScrollReveal delay={100}>
          <IngredientsSection />
        </ScrollReveal>
        
        <ScrollReveal delay={100}>
          <SubscriptionSection />
        </ScrollReveal>
        
        <ScrollReveal delay={100}>
          <NewsletterSection />
        </ScrollReveal>
      </main>
      
      <Footer />
    </>
  );
};

export default Index;
